export const text = {
  CEOMessage: "Organisatie bericht",
  Quicklinks: "Snelkoppelingen",
  Edit: "Bewerken",
  Add: "Toevoegen",
  selectbanner: "Selecteer Banner",
  selectvideo: "Selecteer Video",
  Message: "Message",
  EnterName: "Naam",
  EnterLink: "Link",
  selectIcon: "Selecteer Icoon",
  AreyousureyouwanttodeletethisQuicklinks:
    "Weet u zeker dat u deze snelkoppelingen wilt verwijderen?",
  NoQuicklinks: "Geen snelkoppelingen",
  CEOMessageupdatedsuccessfully: "Organisatie bericht succesvol bijgewerkt",
  QuickLinkupdatedsuccessfully: "Snelkoppeling succesvol bijgewerkt",
  Allfieldsarerequired: "Alle velden zijn verplicht",
  Message: "Bericht",
};
